import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../../language/vn';
import {environment} from '../../../../../environments/environment';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {Color} from 'ng2-charts';
import {NavItemService} from '../../../../service/staff/service-navitem';

@Component({
  selector: 'egov-tonghoplist-vanbandi',
  templateUrl: './tonghoplist.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VanBanDiTongHopListComponent implements OnInit, AfterViewInit {
  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number = 0;
  public totalChuaXem: number = 0;
  public totalDuocXem: number = 0;
  public totalPhoCap: number = 0;
  public totalChuaPhoCap: number = 0;
  public totalChoGiaoXuLy: number = 0;
  public totalDaVaoSo: number = 0;
  public ty: string = '';
  public status: number[] = [
    environment.chogiaoxuly
  ];
  private statusDangXuLy: number = environment.dangxuly;
  private statusChuaXuLy: number = environment.chuaxuly;
  private statusHoanThanh: number = environment.hoanthanh;
  public phoCap: number = -1;
  public nguoiNhapId: number = Sessioncommand.staffId;
  public nguoiChuTri: number =-1;
  public maNoiGui: number =-1;
  public permissionVaoSo: boolean = false;
  public permissionChoGiaoXuLy: boolean = false;
  public permissionDaVaoSo: boolean = false;
  public permissionInSoCV: boolean = false;
  public permissionQLSo: boolean = false;
  public permissionVBDXuLy: boolean = false;
  public permissionVBDDuocXem: boolean = false;
  public permissionQLPhoCap: boolean = false;
  public language = language;
  constructor(
    public vanBanDiService: VanBanDiService,
    public navItemService: NavItemService
  ) {
  }
  ngAfterViewInit() {
    this.loadTotal();
  }
  ngOnInit(): void {
    this.navItemService.findALlByStaffId(Sessioncommand.staffId, 3, true).subscribe(
      x => {
        this.permissionVaoSo = x.findIndex(y => y.code === 'VBDIVS' ) !== -1;
        this.permissionChoGiaoXuLy = x.findIndex(y => y.code === 'VBDICGXL' ) !== -1;
        this.permissionDaVaoSo = x.findIndex(y => y.code === 'VBDIDVS' ) !== -1;
        this.permissionInSoCV = x.findIndex(y => y.code === 'VBDIINSCV' ) !== -1;
        this.permissionQLSo = x.findIndex(y => y.code === 'VBDIQLS' ) !== -1;
        this.permissionVBDXuLy = x.findIndex(y => y.code === 'VBDIXL' ) !== -1;
        this.permissionVBDDuocXem = x.findIndex(y => y.code === 'VBDIDX' ) !== -1;
        this.permissionQLPhoCap = x.findIndex(y => y.code === 'VBDIQLPC' ) !== -1;
        let nguoiGiaoXuLy: number = this.permissionChoGiaoXuLy  ? -1: this.nguoiNhapId;
        this.vanBanDiService.getCountByKeyword(-1, '',-1,-1, environment.chogiaoxuly.toString(), CommandUtil.defaultValue, nguoiGiaoXuLy, this.nguoiChuTri,'','').subscribe(recordCount => this.totalChoGiaoXuLy = recordCount);

      }
    );
  }
  public loadTotal()
  {
    this.vanBanDiService.getCountByKeyword(-1, '', -1,-1,'-1', CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, '','').subscribe(recordCount => this.totalDaVaoSo = recordCount);
    this.vanBanDiService.getCountByXLKeyword('',-1,-1, environment.chuaxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1, '','').subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.vanBanDiService.getCountByXLKeyword('', -1,-1,environment.dangxuly.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1, '','').subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.vanBanDiService.getCountByXLKeyword('',-1,-1, environment.hoanthanh.toString(), CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, -1, '','').subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.vanBanDiService.getCountByKeyword(-1, '', -1,-1,'-1', CommandUtil.daPhoCap, this.nguoiNhapId, this.nguoiChuTri, '','').subscribe(recordCount => this.totalPhoCap = recordCount);
    this.vanBanDiService.getCountByKeyword(-1, '',-1,-1, '-1', CommandUtil.chuaPhoCap, this.nguoiNhapId, this.nguoiChuTri, '','').subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    this.vanBanDiService.getCountByXLKeyword('', -1,-1,'-1', CommandUtil.defaultValue, this.nguoiNhapId, this.nguoiChuTri, 0, '','').subscribe(recordCount => this.totalChuaXem = recordCount);
  }

}

